import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TenantChooserDialogContentComponent } from './tenant-chooser-dialog-content.component';

@Component({
  selector: 'tenant-chooser-dialog',
  template: '',
})
export class TenantChooserDialogComponent {
  static contentComponent = TenantChooserDialogContentComponent;

  @Input() options: MatDialogConfig = { autoFocus: true };

  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  dialogRef: any;

  constructor(private dialog: MatDialog) {}

  open() {
    const dialogRef = this.dialog.open(
      TenantChooserDialogContentComponent,
      this.options,
    );
    const instance = dialogRef.componentInstance;
    instance['selected'].subscribe((value: any) => {
      this.selected.emit(value);
    });
    this.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  close() {
    if (this.dialogRef) this.dialogRef.close();
  }
}
